<template>
  <RF-Dialog class="sub-get-info-clu"
    :cpntStatus='statusGeral'
    :cpntLargura='"950px"'
    :cpntFundoFechar="cpntFundoFechar"
    :cpntOnFecharDialog='subGerInfCluFechar'>
    <template slot="titulo">
      <!-- SETA O ICONE DA ABA -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="cpntTipo === 'pacotes'">
        Pacotes da Licença de Uso {{ cpntClu }}
      </template>
      <template v-else-if="cpntTipo === 'pagamento'">
        Pagamentos da Licença de Uso {{ cpntClu }}
      </template>
      <template v-else-if="cpntTipo === 'certificado'">
        Certificado digital da Licença de uso {{ cpntClu }}
      </template>
    </template>

    <template slot="conteudo">
      <!-- SETA A ABERTURA DA TELA DE MEUS PAGAMENTOS -->
      <RF-Pacotes-Contratados v-if="cpntTipo === 'pacotes'" :cpntClu="cpntClu" :cpntFecharFormulario="subGerInfCluFechar"></RF-Pacotes-Contratados>

      <!-- SETA A ABERTURA DA TELA DE MEUS PAGAMENTOS -->
      <RF-Meus-Pagamentos v-else-if="cpntTipo === 'pagamento'" :cpntClu="cpntClu" :cpntDialog="true"></RF-Meus-Pagamentos>

      <!-- SETA A TELA DE CERTIFICADO DIGITAL -->
      <RF-Certificado-Digital v-else-if="cpntTipo === 'certificado'" :cpntClu="cpntClu" :cpntFecharFormulario="subGerInfCluFechar"></RF-Certificado-Digital>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
.sub-get-info-clu .app-dialog-contant {
  padding: 10px 7px 10px 15px !important;
}
</style>

<script>
  export default {
    props: {
      cpntClu: {
        require: true
      },
      cpntTipo: {
        require: true
      },
      cpntFundoFechar: {
        require: false,
        default: function () {
          return true
        }
      },
      cpntFecharFormulario: {
        require: true
      }
    },
    components: {
      'RF-Pacotes-Contratados': () => import('@/components/config/pacotes/RF-Pacotes-Contratados.vue'),
      'RF-Meus-Pagamentos': () => import('@/components/cobranca/meus-pagamentos/Meus-Pagamentos.vue'),
      'RF-Certificado-Digital': () => import('@/components/subase/gerenciar/Subase-Gerenciar-Certificado-Digital')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando'
      }
    },
    mounted: function () {
      this.subGerInfCluIniciar()
    },
    methods: {
      subGerInfCluIniciar: function () {
        if ([ 'pag_setup_2' ].indexOf(this.$route.name) !== -1) {
          // VERIFICA SE TEM APENAS UM PACOTE
          if (this.$store.state.token.clu_pcc.length === 1) {
            // SETA OS PACOTES PADRÕES PARA COMEÇAR
            var pacotes = [ 1, 21, 17 ]
            
            // VERIFICA O PACOTE QUE TEM QUE COLOCAR PARA CADA INTENÇÃO
            switch (this.$store.state.licenca.intencao) {
              case 'oficina':
                pacotes = pacotes.concat([ 4, 6, 8, 15, 20, 23, 25 ])
                break
  
              case 'petshop':
                pacotes = pacotes.concat([ 4, 6, 28, 15, 20, 23, 25 ])
                break
  
              default:
                pacotes = pacotes.concat([ 4, 6, 20, 23 ])
                break
            }
            // pacotes = [ 1, 21 ]

            // CONVERTE O VALOR DOS PACOTES EM UM JSON
            var formData = { j_pacotes: JSON.stringify(pacotes) }

            // FAZ A COMUNICAÇÃO COM A API
            this.$store.state.comunicaAPI('/config/pacote', 'PUT', formData, () => {
              // SETA A PAGINA COM O STATUS DE CARREGANDO
              this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }, { chave: 'setup', value: true }])

              // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
              const SESSAO_ATUALIZAR_TOKEN = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_TOKEN

              // MANDA ATUALIZAR OS PACOTES NO TOKEN
              SESSAO_ATUALIZAR_TOKEN('clu_pcc', () => {
                setTimeout(() => {
                  // REMOVE A MASCARA DE CARREGANDO
                  this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'setup', value: false }])

                  // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
                  this.subGerInfCluIniciar()
                }, 300)
              })
            }, this.subGerInfCluISetarStatusGeral, (apiValid, apiStatus) => {
              this.subGerInfCluISetarStatusGeral({ loc: 'API', cod: apiStatus, err: apiValid.geralWeb })
            })
          } else {
            this.subGerInfCluISetarStatusGeral('')  
          }
        } else {
          this.subGerInfCluISetarStatusGeral('')
        }
      },
      subGerInfCluISetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      subGerInfCluFechar: function (atualizar, params1, params2) {
        if ([ 'pag_setup_2' ].indexOf(this.$route.name) !== -1) {
          // REMOVE A MASCARA DE CARREGANDO
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'setup', value: false }])

          // MANDA ABRIR A TELA DESEJADA
          this.$router.push({ name: 'iniciante', params: { cts: this.$store.state.token.cts } })
        } else {
          this.cpntFecharFormulario(atualizar, params1, params2)
        }
      }
    }
  }
</script>
